// extracted by mini-css-extract-plugin
module.exports = {"chip":"PointChip_chip__3Tfh_","label":"PointChip_label__2od7J","labelError":"PointChip_labelError__3Z0dX","rotate":"PointChip_rotate__2hFLv"};